<template>
  <div class="wrap">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="addBtn">
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-plus"
        @click="addRoles()"
        >新增角色</el-button
      >
    </div>
    <el-table
      :data="tableData"
      style="width: 362px"
      border
    >
      <el-table-column
        prop="role_name"
        label="角色名称"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column align="center" width="180" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div
      v-show="addShow"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      class="addBox"
    >
      <div class="addBoxC">
        <el-form ref="form" :model="addForm" label-width="80px" size="mini">
          <el-form-item label="角色名称">
            <el-input v-model="addForm.role_name"></el-input>
          </el-form-item>
          <el-form-item label="可用模块">
            <el-tree
              :data="menuData"
              show-checkbox
              default-expand-all
              node-key="menu_id"
              ref="tree"
              highlight-current
              :props="defaultProps"
            >
            </el-tree>
          </el-form-item>

          <el-form-item size="large">
            <el-button size="mini" @click="getCheckedNodes()" type="primary"
              >立即创建</el-button
            >
            <el-button size="mini" @click="colseAddBox()">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div
      v-show="editShow"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      class="addBox"
    >
      <div class="addBoxC">
        <el-form ref="form" :model="editForm" label-width="80px" size="mini">
          <el-form-item label="角色名称">
            <el-input v-model="editForm.role_name"></el-input>
          </el-form-item>
          <el-form-item label="可用模块">
            <el-tree
              :data="menuData"
              show-checkbox
              default-expand-all
              node-key="menu_id"
              ref="editTree"
              highlight-current
              :props="defaultProps"
            >
            </el-tree>
          </el-form-item>

          <el-form-item size="large">
            <el-button size="mini" @click="editSubmit()" type="primary"
              >确定</el-button
            >
            <el-button size="mini" @click="colseAddBox()">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // name: "order",
  data() {
    return {
      tableData: [],
      addForm: {
        role_name: "",
      },
      editForm: {
        role_name: "",
      },
      menuData: [],
      defaultProps: {
        children: "menu",
        label: "menu_name",
        disabled: this.initDisabled,
      },
      loading: false,
      addShow: false,
      editShow: false,
    };
  },
  created: function () {
    this.getRole();
    this.getMenu();
  },
  methods: {
    async handleEdit(index, row) {
      index;
      let role_id = row.role_id;
      let params = {
        role_id: role_id,
      };
      let res = await this.$Http.getEditRole(params);
      if (res.code == 0) {
        this.editForm = res.data.ScmRole;
        let keys = [];
        for (let i in res.data.ScmRoleright) {
          keys.push(res.data.ScmRoleright[i]);
        }
        this.$refs.editTree.setCheckedKeys(keys);
        this.editShow = true;
      } else {
        this.$message.error(res.msg);
        this.loading = false;
      }
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let role_id = row.role_id;
          let params = {
            role_id,
          };
          let res = await this.$Http.deleteRole(params);
          if (res.code == 0) {
            this.getRole();
            this.$message({
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message.error(res.msg);
            this.loading = false;
          }
        })
        .catch(() => {});
    },
    /**
     * 获取角色列表
     */
    async getRole() {
      let res = await this.$Http.getRole();
      if (res.code == 0) {
        this.tableData = res.data;
      } else {
        this.$message.error("获取数据时异常！请稍后重试");
      }
    },
    /**
     * 获取菜单列表
     */
    async getMenu() {
      let res = await this.$Http.menu();
      if (res.code == 0) {
        let menu = [];
        let i = 0;
        res.data.forEach((element) => {
          if (!element.superior_id) {
            menu.push({
              menu_id: element.menu_id,
              menu_name: element.menu_name,
              menu: [],
            });
            i++;
          }
          if (element.superior_id) {
            menu[i - 1].menu.push({
              menu_id: element.menu_id,
              menu_name: element.menu_name,
              superior_id: element.superior_id,
            });
          }
        });
        this.menuData = menu;
      } else {
        this.$message.error(res.msg);
      }
    },
    /**
     * 获取选中的menu
     */
    async getCheckedNodes() {
      // console.log(this.$refs.tree.getCheckedNodes());
      if (!this.addForm.role_name) {
        this.$message({
          message: "请输入角色名称",
          type: "warning",
        });
        return;
      }
      let menuData = this.$refs.tree.getCheckedNodes();
      if (menuData.length < 1) {
        this.$message({
          message: "至少选择一个可用菜单",
          type: "warning",
        });
        return;
      }
      let menu = [];
      menuData.forEach((item) => {
        if (item.superior_id) {
          if (menu.indexOf(item.superior_id) == -1) {
            menu.push(item.superior_id);
          }
        }
        menu.push(item.menu_id);
      });
      let role_name = this.addForm.role_name;
      let params = {
        role_name: role_name,
        menu: menu,
      };
      this.loading = true;
      let res = await this.$Http.createRole(params);
      if (res.code == 0) {
        this.loading = false;
        this.addShow = false;
        this.getRole();
        this.$refs.tree.setCheckedKeys([]);
        this.addForm.role_name = "";
        this.$message({
          message: "创建成功",
          type: "success",
        });
      } else {
        this.$message.error(res.msg);
        this.loading = false;
      }
    },
    /**
     * 禁止勾选一级菜单
     */
    initDisabled(data, node) {
      // console.log(data)
      // console.log(node)
      node;
      if (!data.superior_id) {
        return data.menu_id;
      }
    },
    /**
     * 新增角色
     */
    addRoles() {
      this.addShow = true;
    },
    /**
     * 关闭窗口
     */
    colseAddBox() {
      this.addShow = false;
      this.editShow = false;
      this.$refs.tree.setCheckedKeys([]);
      this.addForm.role_name = "";
    },
    /**
     * 编辑提交
     */
    async editSubmit() {
      if (!this.editForm.role_name) {
        this.$message({
          message: "角色名称不能为空",
          type: "warning",
        });
        return;
      }
      let menuData = this.$refs.editTree.getCheckedNodes();
      if (menuData.length < 1) {
        this.$message({
          message: "至少选择一个可用菜单",
          type: "warning",
        });
        return;
      }
      let menu = [];
      menuData.forEach((item) => {
        if (item.superior_id) {
          if (menu.indexOf(item.superior_id) == -1) {
            menu.push(item.superior_id);
          }
        }
        menu.push(item.menu_id);
      });
      let editForm = this.editForm;
      let params = {
        editForm: editForm,
        menu: menu,
      };
      this.loading = true;
      let res = await this.$Http.editRole(params);
      if (res.code == 0) {
        this.loading = false;
        this.editShow = false;
        this.getRole();
        this.$refs.editTree.setCheckedKeys([]);
        this.$message({
          message: "修改成功",
          type: "success",
        });
      } else {
        this.$message.error(res.msg);
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.wrap {
  padding: 0 20px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
  position: relative;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.addBtn {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 0;
}
.addBox {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: 99;
}
.addBoxC {
  width: 400px;
  background-color: #fff;
  padding: 15px;
  border-radius: 3px;
}
</style>